module.exports = __webpack_public_path__ + "akne_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_1_after.jpg
// module id = 915
// module chunks = 0